module.exports = __webpack_public_path__ + "media/images/Star-504e7b4ee133c326bb0eee01fd067812.png";